/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Settlement tenor, can be values "T+0" or "T+2" for T+0 or T+2 respectively, only required if transfer requires tenor selection
 */
export type SendRequestTenor = typeof SendRequestTenor[keyof typeof SendRequestTenor];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SendRequestTenor = {
  T0: 'T+0',
  T1: 'T+1',
  T2: 'T+2',
} as const;
